import { render, staticRenderFns } from "./ProvinceRisk.vue?vue&type=template&id=3e403f86&scoped=true"
import script from "./ProvinceRisk.vue?vue&type=script&lang=js"
export * from "./ProvinceRisk.vue?vue&type=script&lang=js"
import style0 from "./ProvinceRisk.vue?vue&type=style&index=0&id=3e403f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e403f86",
  null
  
)

export default component.exports